export const teamInitialState = {
	fundraisers: [],
};



// WEBPACK FOOTER //
// ./src/redux/teams/team.initialState.js